import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {TargetService} from '../../../../target/target.service';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-export-prices-dialog',
  template: `
    <p>
      Please wait! This operation can take up to 2-3 minutes!
    </p>
    <div class="loading">
      <mat-progress-bar mode="query"></mat-progress-bar>
    </div>
  `,
  styleUrls: ['./export-prices-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportPricesDialogComponent implements OnInit {

  constructor(private targetService: TargetService,
              private dialogRef: MatDialogRef<ExportPricesDialogComponent>) { }

  ngOnInit(): void {
    this.targetService.downloadXlsxPrices()
      .subscribe(response=> {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'segment-prices-'+new Date().getTime()+'.xlsx';
        link.click();
        this.dialogRef.close();
    });
  }
}
